import type { ReactNode } from "react";
import { useFieldInfoLabels } from "@/services/field-info/use-field-info-labels";
import {
	defaultFieldInfoLabelsValue,
	FieldInfoLabelsContext,
} from "./FieldInfoLabelsContext";

/**
 * Mount once (e.g. in router Wrap) so field-info list queries run a single time app-wide.
 * Kept separate from FieldInfoLabelsContext so consumers of `useFieldInfoLabelsContext`
 * do not import `useFieldInfoLabels` / the field-info service graph.
 *
 * During TanStack Start static prerender (`TSS_PRERENDERING`), we skip `useQueries` so
 * React Query's internal timers do not keep the Node build process alive after prerender.
 */
export function FieldInfoLabelsProvider({ children }: { children: ReactNode }) {
	const isStaticPrerender =
		typeof process !== "undefined" && process.env.TSS_PRERENDERING === "true";

	if (isStaticPrerender) {
		return (
			<FieldInfoLabelsContext.Provider value={defaultFieldInfoLabelsValue}>
				{children}
			</FieldInfoLabelsContext.Provider>
		);
	}

	return (
		<FieldInfoLabelsProviderInner>{children}</FieldInfoLabelsProviderInner>
	);
}

function FieldInfoLabelsProviderInner({ children }: { children: ReactNode }) {
	const value = useFieldInfoLabels();
	return (
		<FieldInfoLabelsContext.Provider value={value}>
			{children}
		</FieldInfoLabelsContext.Provider>
	);
}
